import { gql } from '@apollo/client'

const MutationDeleteVirtualAssetFiles = gql(`
    mutation deleteVirtualAssetFiles($input: [ID],  $assetId: ID, $project: String $module: String) {
        deleteVirtualAssetFiles(
            input: $input,
            assetId: $assetId,
            project: $project
            module: $module
        )
    }`
)

export default MutationDeleteVirtualAssetFiles
